/**
 * MediaQueryList.addEventListener("change") no existe en Chrome < 88
 * (WebViews de Android antiguos / Instagram in-app).
 */
export function subscribeMediaQuery(mediaQuery, listener) {
	if (!mediaQuery) return function () {};

	if (typeof mediaQuery.addEventListener === "function") {
		mediaQuery.addEventListener("change", listener);
		return function () {
			mediaQuery.removeEventListener("change", listener);
		};
	}

	if (typeof mediaQuery.addListener === "function") {
		mediaQuery.addListener(listener);
		return function () {
			mediaQuery.removeListener(listener);
		};
	}

	return function () {};
}
